import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import Api from "../Api/Api.json";

const fetchData = async (id, date) => {
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.PREGNANCY_DATA_API;
    const requestData = {
        task: "getANCDataFormOnDate",
        patient_id: id,
        creation_date: date,
    };
    const response = await axios.post(url, requestData, headers);
    if (!response.data) {
        throw new Error("Network response was not ok");
    }
    return response.data[0];
}

export const useANCData = (id, date) => {
    // Use React Query to fetch and cache data
    return useQuery({
        queryKey: ["ancData", id, date], // Unique key for this query
        queryFn: () => fetchData(id, date), // Function to fetch data
        staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
        cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
        enabled: !!date, // Disable the query by default, it will be triggered on a button click
    });
}